import axios from "axios";
import { cmsHeaders, headers } from "../exports/exports";

export const fetchSchoolDetails = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-school-details?populate=*`,
      { headers },
    );
    return response.data.data.slice(-1);
  } catch (error) {
    console.error("Server Error", error);
  }
};

export const fetchCalendar = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/calendar?sort=year:asc`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error", error);
  }
};

export const fetchAllBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/banner`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error", error);
  }
};
